// extracted by mini-css-extract-plugin
export default {"navItems":"Nav_navItems__sN7Ye","logo":"Nav_logo__brjJ2","navList":"Nav_navList__EuziR","navLinks":"Nav_navLinks__ftc3A"};